import { proxy } from 'valtio';
import { BrowserState, LocaleSource, MicrophoneAccessType } from './types';
import { detectSupportedLocale } from './lib/detectSupportedLocale';

export const browserState = proxy<BrowserState>({
  microphoneAccess: MicrophoneAccessType.UNKNOWN,
  tries: 0,
  showMicrophoneAccessModal: false,
  isOnline: navigator.onLine,
  localeState: {
    locale: detectSupportedLocale(),
    source: LocaleSource.Inference,
    isLoading: false,
  },
});
